import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileBend: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="file-bend, document"><path d="M12 2H7.75C5.67893 2 4 3.67893 4 5.75V18.25C4 20.3211 5.67893 22 7.75 22H16.25C18.3211 22 20 20.3211 20 18.25V10H14.75C13.2312 10 12 8.76878 12 7.25V2Z" fill="currentColor"/><path d="M19.5566 8.49993C19.5343 8.47493 19.5112 8.45051 19.4874 8.4267L13.5732 2.51249C13.5494 2.48868 13.525 2.46564 13.5 2.44336V7.24993C13.5 7.94028 14.0596 8.49993 14.75 8.49993H19.5566Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFileBend;
